module.exports = __webpack_public_path__ + "img/UHF LED RFID标签.267a991f.jpg";